export default "__VITE_ASSET__ICNav74B__"